exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-form-change-pass-user .help p.success{color:#48c78e}.modal-form-change-pass-user .help p.danger{color:#f14668}.modal-form-change-pass-user .help p .icon{margin-left:8px;width:auto}.modal-form-change-pass-user .help p .icon .mdi:before{font-size:12px}.modal-form-change-pass-user .content-btns{text-align:right}", ""]);

// exports
